module.exports = __webpack_public_path__ + "img/appAsset--certificate-ax.6493c374.svg";